module.exports = __webpack_public_path__ + "static/media/smallestTarget.4448d69d.svg";